var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between"},[_c('h1',{staticClass:"page-header"},[_vm._v(_vm._s(_vm.$t('promotion.pageTitle')))]),_c('ts-breadcrumb',{attrs:{"items":[
      { text: _vm.$t('home'), href: '/' },
      {
        text: _vm.$t('promotion.pageTitle'),
        href: '/admin/promotions',
      },
      {
        text: _vm.$t('edit'),
        active: true,
      } ]}})],1),_c('ts-card',[_c('ts-card-wrapper',[_c('ts-loading-banner',{attrs:{"loading":_vm.loading}},[_c('a-tabs',{attrs:{"default-active-key":"6"}},[_c('a-tab-pane',{key:"6",attrs:{"tab":_vm.$t('promotion.discountByRange')}},[_c('DiscountByRangeForm',{ref:"discountByRangeForm"})],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }